import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import MuiSelect from '@mui/material/Select'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import Box from '@mui/material/Box'

import {pickAttributes} from '../../../../helpers/utils'

const useStyles = makeStyles(selectStyles)

export default function Select (props) {

  const classes = useStyles()

  const controlAttributes = pickAttributes(props, 'control')
  const selectAttributes = pickAttributes(props, 'select')

  const labelId = `${props.id}-label`

  return (
    <Box className={clsx(classes.root, props.className)}>
      <Box className={clsx(classes.label, "label")}>{props.caption}:</Box>
      <Box className={clsx(classes.input, "input")}>
        {props.options.length > 0 && (
        <FormControl
          {...controlAttributes}
          className={classes.control}
        >
          {(props.nullable || selectAttributes.value) &&
            <MuiSelect
              labelId={labelId}
              id={props.id}
              {...selectAttributes}
              className={clsx(classes.select, "select")}
            >
              {props.options.map((option, key) => (
                <MenuItem value={props.mapValue(option)} key={key}>{props.mapText(option)}</MenuItem>)
              )}
            </MuiSelect>
          }
        </FormControl>)}
      </Box>
    </Box>
  )
}


function selectStyles(theme) {
  return {
    root: {
      '& .MuiInput-underline:before': {
        content: 'none',
        border: 'none'
      },
      '& .MuiSelect-select': {
        border: 'solid 1px #aab7bf',
        borderRadius: 4,
        padding: 5,
        paddingRight: 24
      },
    },
    control: {
      margin: 0,
      flexGrow: 1
    }
  }
}
